"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _aciCastello = _interopRequireDefault(require("./24_group_2023_09_18/aci-castello"));

var _afragola = _interopRequireDefault(require("./24_group_2023_09_18/afragola"));

var _agazzano = _interopRequireDefault(require("./24_group_2023_09_18/agazzano"));

var _agliana = _interopRequireDefault(require("./24_group_2023_09_18/agliana"));

var _alpago = _interopRequireDefault(require("./24_group_2023_09_18/alpago"));

var _argelato = _interopRequireDefault(require("./24_group_2023_09_18/argelato"));

var _arzachena = _interopRequireDefault(require("./24_group_2023_09_18/arzachena"));

var _assisi = _interopRequireDefault(require("./24_group_2023_09_18/assisi"));

var _atina = _interopRequireDefault(require("./24_group_2023_09_18/atina"));

var _bastiaUmbra = _interopRequireDefault(require("./24_group_2023_09_18/bastia-umbra"));

var _bleggioSuperiore = _interopRequireDefault(require("./24_group_2023_09_18/bleggio-superiore"));

var _brugherio = _interopRequireDefault(require("./24_group_2023_09_18/brugherio"));

var _campobasso = _interopRequireDefault(require("./24_group_2023_09_18/campobasso"));

var _cantarana = _interopRequireDefault(require("./24_group_2023_09_18/cantarana"));

var _caorle = _interopRequireDefault(require("./24_group_2023_09_18/caorle"));

var _casalecchioDiReno = _interopRequireDefault(require("./24_group_2023_09_18/casalecchio-di-reno"));

var _castelGandolfo = _interopRequireDefault(require("./24_group_2023_09_18/castel-gandolfo"));

var _castelVolturno = _interopRequireDefault(require("./24_group_2023_09_18/castel-volturno"));

var _ceccano = _interopRequireDefault(require("./24_group_2023_09_18/ceccano"));

var _cecina = _interopRequireDefault(require("./24_group_2023_09_18/cecina"));

var _coli = _interopRequireDefault(require("./24_group_2023_09_18/coli"));

var _comelicoSuperiore = _interopRequireDefault(require("./24_group_2023_09_18/comelico-superiore"));

var _corciano = _interopRequireDefault(require("./24_group_2023_09_18/corciano"));

var _coriglianoRossano = _interopRequireDefault(require("./24_group_2023_09_18/corigliano-rossano"));

var _cusanoMilanino = _interopRequireDefault(require("./24_group_2023_09_18/cusano-milanino"));

var _dossena = _interopRequireDefault(require("./24_group_2023_09_18/dossena"));

var _enemonzo = _interopRequireDefault(require("./24_group_2023_09_18/enemonzo"));

var _falconaraMarittima = _interopRequireDefault(require("./24_group_2023_09_18/falconara-marittima"));

var _fasano = _interopRequireDefault(require("./24_group_2023_09_18/fasano"));

var _finaleEmilia = _interopRequireDefault(require("./24_group_2023_09_18/finale-emilia"));

var _framura = _interopRequireDefault(require("./24_group_2023_09_18/framura"));

var _frosinone = _interopRequireDefault(require("./24_group_2023_09_18/frosinone"));

var _giarre = _interopRequireDefault(require("./24_group_2023_09_18/giarre"));

var _imperia = _interopRequireDefault(require("./24_group_2023_09_18/imperia"));

var _ischia = _interopRequireDefault(require("./24_group_2023_09_18/ischia"));

var _lanuvio = _interopRequireDefault(require("./24_group_2023_09_18/lanuvio"));

var _marciana = _interopRequireDefault(require("./24_group_2023_09_18/marciana"));

var _minturno = _interopRequireDefault(require("./24_group_2023_09_18/minturno"));

var _moglia = _interopRequireDefault(require("./24_group_2023_09_18/moglia"));

var _mondragone = _interopRequireDefault(require("./24_group_2023_09_18/mondragone"));

var _monfalcone = _interopRequireDefault(require("./24_group_2023_09_18/monfalcone"));

var _monsummanoTerme = _interopRequireDefault(require("./24_group_2023_09_18/monsummano-terme"));

var _montafia = _interopRequireDefault(require("./24_group_2023_09_18/montafia"));

var _montecchioMaggiore = _interopRequireDefault(require("./24_group_2023_09_18/montecchio-maggiore"));

var _montefiascone = _interopRequireDefault(require("./24_group_2023_09_18/montefiascone"));

var _montemurlo = _interopRequireDefault(require("./24_group_2023_09_18/montemurlo"));

var _nardo = _interopRequireDefault(require("./24_group_2023_09_18/nardo"));

var _piacenza = _interopRequireDefault(require("./24_group_2023_09_18/piacenza"));

var _pimonte = _interopRequireDefault(require("./24_group_2023_09_18/pimonte"));

var _polignanoAMare = _interopRequireDefault(require("./24_group_2023_09_18/polignano-a-mare"));

var _pontiSulMincio = _interopRequireDefault(require("./24_group_2023_09_18/ponti-sul-mincio"));

var _portoRecanati = _interopRequireDefault(require("./24_group_2023_09_18/porto-recanati"));

var _potenza = _interopRequireDefault(require("./24_group_2023_09_18/potenza"));

var _sanDamianoDAsti = _interopRequireDefault(require("./24_group_2023_09_18/san-damiano-d-asti"));

var _sanGiovanniValdarno = _interopRequireDefault(require("./24_group_2023_09_18/san-giovanni-valdarno"));

var _sanTeodoroSs = _interopRequireDefault(require("./24_group_2023_09_18/san-teodoro-ss"));

var _santaTeresaGallura = _interopRequireDefault(require("./24_group_2023_09_18/santa-teresa-gallura"));

var _saronno = _interopRequireDefault(require("./24_group_2023_09_18/saronno"));

var _segusino = _interopRequireDefault(require("./24_group_2023_09_18/segusino"));

var _sestriLevante = _interopRequireDefault(require("./24_group_2023_09_18/sestri-levante"));

var _subiaco = _interopRequireDefault(require("./24_group_2023_09_18/subiaco"));

var _vetralla = _interopRequireDefault(require("./24_group_2023_09_18/vetralla"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _aciCastello["default"], {}, _afragola["default"], {}, _agazzano["default"], {}, _agliana["default"], {}, _alpago["default"], {}, _argelato["default"], {}, _arzachena["default"], {}, _assisi["default"], {}, _atina["default"], {}, _bastiaUmbra["default"], {}, _bleggioSuperiore["default"], {}, _brugherio["default"], {}, _campobasso["default"], {}, _cantarana["default"], {}, _caorle["default"], {}, _casalecchioDiReno["default"], {}, _castelGandolfo["default"], {}, _castelVolturno["default"], {}, _ceccano["default"], {}, _cecina["default"], {}, _coli["default"], {}, _comelicoSuperiore["default"], {}, _corciano["default"], {}, _coriglianoRossano["default"], {}, _cusanoMilanino["default"], {}, _dossena["default"], {}, _enemonzo["default"], {}, _falconaraMarittima["default"], {}, _fasano["default"], {}, _finaleEmilia["default"], {}, _framura["default"], {}, _frosinone["default"], {}, _giarre["default"], {}, _imperia["default"], {}, _ischia["default"], {}, _lanuvio["default"], {}, _marciana["default"], {}, _minturno["default"], {}, _moglia["default"], {}, _mondragone["default"], {}, _monfalcone["default"], {}, _monsummanoTerme["default"], {}, _montafia["default"], {}, _montecchioMaggiore["default"], {}, _montefiascone["default"], {}, _montemurlo["default"], {}, _nardo["default"], {}, _piacenza["default"], {}, _pimonte["default"], {}, _polignanoAMare["default"], {}, _pontiSulMincio["default"], {}, _portoRecanati["default"], {}, _potenza["default"], {}, _sanDamianoDAsti["default"], {}, _sanGiovanniValdarno["default"], {}, _sanTeodoroSs["default"], {}, _santaTeresaGallura["default"], {}, _saronno["default"], {}, _segusino["default"], {}, _sestriLevante["default"], {}, _subiaco["default"], {}, _vetralla["default"]);

exports["default"] = _default;